/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Base Modules (@accedo/xdk-base-modules) 4.2.8
* 
*******************************************************************************/
import{klass,AbstractNetwork}from"@accedo/xdk-core";let NAVIGATOR_DEFINED="undefined"!=typeof navigator;const BaseHTML5Network=klass.create(AbstractNetwork,{},{init(){this._super(),this.__checkNetworkStatus()},getConnectionStatus(){return Promise.resolve(this._isInternetConnected())},_isInternetConnected:()=>NAVIGATOR_DEFINED&&navigator.onLine});export default BaseHTML5Network;